import { FC } from "react";
import { Logo } from "../..";

import styles from "./Content.module.scss";
import { CarouselItem } from "../../../utils/pagesData";

interface ContentProps {
  page: "home" | "bar";
  info: CarouselItem;
  icon: string;
}

export const ContentCarousel: FC<ContentProps> = ({ page, info, icon }) => {
  return (
    <>
      {page === "home" ? (
        <Logo className={styles.logo} />
      ) : (
        <div className={styles.container}>
          <div className={styles.text}>
            <div className={styles.title}>{info.title}</div>
            <div className={styles.description}>{info.description}</div>
          </div>
        </div>
      )}
    </>
  );
};
